import React from 'react';
import card1 from '@/common/assets/images/card1.jpg';
import card2 from '@/common/assets/images/card2.jpg';
import Profiles from './Profiles';
const Visitors = () => {
  const DUMMY = [
    {
      pic: card2,
      code: 'ABC1234',
      name: 'Rengoku',
      dob: '28 yrs',
      height: '5’ 9”',
      marriedStatus: 'Unmarried',
      address: 'Mumbai',
      occupation: 'Working',
      education: 'MBA, Finance',
      income: 'Rs 10-12 L',
      isNew: true,
      isFavourite: true
    },
    {
      pic: card1,
      code: 'ABC1234',
      name: 'Rengoku',
      dob: '28 yrs',
      height: '5’ 9”',
      marriedStatus: 'Unmarried',
      address: 'Mumbai',
      occupation: 'Working',
      education: 'MBA, Finance',
      income: 'Rs 10-12 L',
      isNew: true,
      isFavourite: true
    }
  ];
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginLeft: '25px'
      }}
    >
      <div
        style={{
          // margin: "0.75rem",
          paddingTop: '15px',
          paddingBottom: '30px'
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '430px 430px 430px',
            gap: '2rem'
          }}
        >
          {DUMMY.map((partner, index) => (
            <Profiles key={index} data={partner} /> // Using index as key (better if code was unique)
          ))}
        </div>
      </div>
    </div>
  );
};

export default Visitors;
